import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLazyGetSwapQuoteQuery } from '../../redux/api/authorized/swap';
import { useSelector, useDispatch } from 'react-redux';
import { selectPrivyToken } from '../../redux/slices/auth';
import { useNavigate } from 'react-router-dom';
import BetsButton from '../Vets/Button';
import { selectTokenBalance } from '../../redux/slices/walletSlice';
import { selectTokenBySymbol } from '../../redux/slices/tokenSlice';
import { Container, ModalContainer } from '../BaseModal';
import { formatUSD } from '../../common/currency';
import { toTokenAmount } from '../../hooks/useSolana';
import BackButton from '../BackButton';
import { selectThemeMode } from '../../redux/slices/themeSlice';

const ButtonsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.text.title};
  font-size: 40px;
  font-weight: 600;
  font-family: Manrope;
`;

const VetsPrice = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 20px;
  font-weight: 600;
  font-family: Manrope;
`;

const YourBalanceLabel = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 16px;
  font-weight: 400;
  font-family: Manrope;
  margin-bottom: -5px;
`;

const VetsBalance = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 36px;
  font-weight: 600;
  font-family: Manrope;
`;

const VetsTokenBalance = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 12px;
  font-weight: 400;
  font-family: Manrope;
`;

const PriceHistoryContainer = styled.div`
  width: 100%;
`;

const ManageVets = () => {
  const vetsBalance = useSelector((state) =>
    selectTokenBalance('solana', vetsToken?.address || '')(state),
  );
  const [vetsPrice, setVetsPrice] = useState(null);
  const [vetsUsdBalance, setVetsUsdBalance] = useState(0);
  const privyToken = useSelector(selectPrivyToken);

  const navigate = useNavigate();
  const [triggerGetSwapQuote] = useLazyGetSwapQuoteQuery();

  const vetsToken = useSelector((state) =>
    selectTokenBySymbol(state, 'solana', 'VETS'),
  );

  useEffect(() => {
    const fetchQuote = async () => {
      const resp = await triggerGetSwapQuote({
        inputMint: vetsToken?.address,
        outputMint: import.meta.env.VITE_SOLANA_USDC_MINT,
        amount: toTokenAmount(1, 9),
      }).unwrap();
      const price = parseInt(resp.quote.outAmount) / 1000000;
      setVetsPrice(price);
    };

    if (privyToken && vetsToken?.address) {
      fetchQuote();
    }
  }, [triggerGetSwapQuote, privyToken, vetsToken?.address]);

  useEffect(() => {
    const fetchQuote = async () => {
      const resp = await triggerGetSwapQuote({
        inputMint: vetsToken?.address,
        outputMint: import.meta.env.VITE_SOLANA_USDC_MINT,
        amount: toTokenAmount(vetsBalance, 9),
      }).unwrap();
      const price = parseInt(resp.quote.outAmount) / 1000000;
      setVetsUsdBalance(price);
    };

    if (privyToken && vetsBalance && vetsToken?.address) {
      fetchQuote();
    }
  }, [triggerGetSwapQuote, privyToken, vetsBalance, vetsToken?.address]);

  const themeMode = useSelector(selectThemeMode);

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <div>
          <Title>VETS</Title>
          <VetsPrice>{formatUSD(vetsPrice)}</VetsPrice>
        </div>
        {vetsToken?.address && (
          <PriceHistoryContainer>
            <iframe
              width='100%'
              height='300'
              src={`https://birdeye.so/tv-widget/${vetsToken?.address}?chain=solana&viewMode=pair&chartInterval=15&chartType=Line&chartTimezone=America%2FNew_York&chartLeftToolbar=hide&theme=${themeMode === 'light' ? 'light' : 'dark'}`}
              frameBorder='0'
              allowFullScreen
            >
              {' '}
            </iframe>
          </PriceHistoryContainer>
        )}
        <div>
          <YourBalanceLabel>Your Balance</YourBalanceLabel>
          <VetsBalance>{formatUSD(vetsUsdBalance)}</VetsBalance>
          <VetsTokenBalance>{vetsBalance} VETS</VetsTokenBalance>
        </div>
        <ButtonsContainer>
          <BetsButton
            fullWidth
            onClick={() => {
              navigate('/app/vets/buy');
            }}
          >
            Buy VETS
          </BetsButton>
          <BetsButton
            secondary
            fullWidth
            onClick={() => {
              navigate('/app/vets/sell');
            }}
          >
            Sell VETS
          </BetsButton>
        </ButtonsContainer>
      </ModalContainer>
    </Container>
  );
};

export default ManageVets;
